import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

import { useIconLib } from '#imports'


export default /*@__PURE__*/_defineComponent({
  __name: 'Menu',
  props: {
  items: {
    type: Array as PropType<MenuItem[]>,
    required: true
  },
  icon: {
    type: String,
    default: 'Actions'
  },
  iconColor: {
    type: String,
    default: 'gray'
  },
  size: {
    type: String,
    default: 'small'
  },
  tooltip: {
    type: String,
    default: ''
  }
},
  setup(__props) {




const ui = useUiStore()

// Get a unique ID for the activator button
const id = useUniqueId('menu')

function processItem(selected: any) {
  const item = __props.items[selected[0]] as MenuItem
  if (item.confirm) {
    confirmAction(item)
  } else {
    executeAction(item)
  }
}

function confirmAction(item: MenuItem) {
  ui.confirmationMessage = item.confirm?.message || `Are you sure you want to perform the action "${item.title}"?`
  ui.confirmationContinue = item.confirm?.confirmText || 'Continue'
  ui.confirmationCancel = item.confirm?.cancelText || 'Cancel'
  ui.confirmationAction = () => { executeAction(item) }
  // Open the confirmation dialog
  ui.confirmation.open()
}

function executeAction(item: MenuItem) {
  if (item.disabled) return

  if (item.to) {
    navigateTo(item.to)
  } else if (item.action) {
    item.action()
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.tooltip)
      ? (_openBlock(), _createBlock(_component_v_tooltip, {
          key: 0,
          bottom: ""
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({ id: _unref(id) }, props, {
              variant: "plain",
              icon: _unref(useIconLib)(__props.icon),
              color: __props.iconColor,
              size: __props.size,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
            }), null, 16, ["id", "icon", "color", "size"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(__props.tooltip), 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          id: _unref(id),
          variant: "plain",
          icon: _unref(useIconLib)(__props.icon),
          color: __props.iconColor,
          size: __props.size,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
        }, null, 8, ["id", "icon", "color", "size"])),
    _createVNode(_component_v_menu, {
      location: "bottom",
      activator: `#${_unref(id)}`
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, {
          rounded: "lg",
          density: "compact",
          class: "hy-actions-menu",
          "onUpdate:selected": processItem
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: index,
                value: index,
                "prepend-icon": item.icon ? _unref(useIconLib)(item.icon) as string : undefined,
                "base-color": item.color || 'gray',
                disabled: item.disabled,
                class: "action-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["value", "prepend-icon", "base-color", "disabled"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activator"])
  ], 64))
}
}

})